import { render, staticRenderFns } from "./SalesClosuresForm.vue?vue&type=template&id=4611bd5a"
import script from "./SalesClosuresForm.vue?vue&type=script&lang=js"
export * from "./SalesClosuresForm.vue?vue&type=script&lang=js"
import style0 from "./SalesClosuresForm.css?vue&type=style&index=0&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4611bd5a')) {
      api.createRecord('4611bd5a', component.options)
    } else {
      api.reload('4611bd5a', component.options)
    }
    module.hot.accept("./SalesClosuresForm.vue?vue&type=template&id=4611bd5a", function () {
      api.rerender('4611bd5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/closings-details/components/SalesClosuresForm.vue"
export default component.exports